import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import axios from "axios";
import "./AdminDashboard.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddAdminVariant = () => {
  const [variantName, setVariantName] = useState("");
  const [variantImage, setVariantImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ Fetch all subcategories for dropdown
  const fetchSubCategories = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/subcategory`
      );
      if (res.data && Array.isArray(res.data)) {
        setSubCategories(res.data);
      } else if (res.data.success) {
        setSubCategories(res.data.subCategories || []);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load subcategories");
    }
  };

  useEffect(() => {
    fetchSubCategories();
  }, []);

  // ✅ Handle image preview
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setVariantImage(file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setPreview(null);
    }
  };

  // ✅ Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!variantName || !variantImage || !selectedSubCategory) {
      toast.warn("Please fill all fields!");
      return;
    }

    const formData = new FormData();
    formData.append("name", variantName);
    formData.append("subcategory", selectedSubCategory);
    formData.append("image", variantImage);

    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/variant`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (res.data.success) {
        toast.success("Variant added successfully!");
        setVariantName("");
        setVariantImage(null);
        setPreview(null);
        setSelectedSubCategory("");
      } else {
        toast.error(res.data.message || "Error adding variant");
      }
    } catch (err) {
      console.error(err.response?.data || err.message);
      toast.error(err.response?.data?.message || "Error adding variant");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout page="add-variant">
      <section className="orders py-5">
        <div className="container">
          <h3 className="mb-4">Add New Variant</h3>

          <div className="add-category-card p-4 bg-white rounded shadow-sm">
            <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
              {/* Variant Name */}
              <div>
                <label className="form-label fw-semibold">Variant Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter variant name"
                  value={variantName}
                  onChange={(e) => setVariantName(e.target.value)}
                  required
                />
              </div>

              {/* Select SubCategory */}
              <div>
                <label className="form-label fw-semibold">
                  Select Subcategory
                </label>
                <select
                  className="form-control"
                  value={selectedSubCategory}
                  onChange={(e) => setSelectedSubCategory(e.target.value)}
                  required
                >
                  <option value="">-- Select Subcategory --</option>
                  {subCategories.map((sub) => (
                    <option key={sub._id} value={sub._id}>
                      {sub.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Variant Image */}
              <div>
                <label className="form-label fw-semibold">Variant Image</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={handleImageChange}
                  required
                />
              </div>

              {/* Image Preview */}
              {preview && (
                <div>
                  <p className="mb-1 fw-semibold">Preview:</p>
                  <img
                    src={preview}
                    alt="Preview"
                    style={{
                      width: "200px",
                      height: "auto",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              )}

              {/* Submit Button */}
              <button
                type="submit"
                className="btn btn-primary mt-2"
                disabled={loading}
              >
                {loading ? "Adding..." : "Add Variant"}
              </button>
            </form>
          </div>
        </div>
      </section>
      <ToastContainer position="top-right" autoClose={2000} />
    </AdminLayout>
  );
};

export default AddAdminVariant;
